export const generateSubstrings = (text: string, n: number) => {
  const regex = `.{1,${n}}`
  const re = new RegExp(regex, 'g')
  return text.match(re) || []
}
